import type * as z from 'zod/mini';

import type { StorageKeySchema, StorageKeySchemaConfig } from '../storage.types';

/** @notInstrumented */
export const createStorageKeySchema = <T>(params: {
  config?: StorageKeySchemaConfig;
  key: string;
  schema: z.ZodMiniType<T>;
}): StorageKeySchema<T> => {
  return params;
};
